(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-cards"] && !Shopify.designMode) return;
  try {
    
/** code by squarestylist.com — standoutshopify.com **/
class SqshHorizontalScroll extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('.sqsh-hscroll__viewport');
    this.track = this.querySelector('[data-track]');
    this.cards = Array.from(this.querySelectorAll('[data-card]'));
    this.bgLayers = Array.from(this.querySelectorAll('.sqsh-hscroll__bg-layer'));
    this.counter = this.querySelector('[data-counter-current]');
    this.activeIndex = -1;
    this.ticking = false;
    this.mode = null;

    if (!this.viewport || !this.track || this.cards.length === 0) return;

    this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    /* Horizon 4.x hands the scroll container to .page-wrapper above 990px.
       Watch that breakpoint so we re-measure when the scroller changes. */
    this.desktop = window.matchMedia('(min-width: 990px)');
    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
    this.applyMode = this.applyMode.bind(this);

    this.applyMode();
    if (this.reduce.addEventListener) {
      this.reduce.addEventListener('change', this.applyMode);
    }
    if (this.desktop.addEventListener) {
      this.desktop.addEventListener('change', this.onResize);
    }
  }

  applyMode() {
    this.teardown();
    if (this.reduce.matches) {
      this.enableNative();
    } else {
      this.enablePinned();
    }
  }

  enablePinned() {
    this.mode = 'pinned';
    this.classList.add('sqsh-hscroll--pinned');
    this.measure();
    /* Capture phase catches scroll from any element, not just window. Scroll
       events do not bubble, so a plain window listener misses Horizon's
       .page-wrapper scroller on desktop. */
    document.addEventListener('scroll', this.onScroll, { capture: true, passive: true });
    window.addEventListener('resize', this.onResize, { passive: true });
    this.update();
  }

  enableNative() {
    this.mode = 'native';
    this.io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.55) {
          this.setActive(parseInt(entry.target.dataset.index, 10));
        }
      });
    }, { root: this.viewport, threshold: [0.55, 0.8] });
    this.cards.forEach((card) => this.io.observe(card));
    this.setActive(0);
  }

  measure() {
    /* Center the first and last cards exactly: leading/trailing space = half the
       leftover width beside one card. Pixel-precise, so it ignores scrollbar quirks. */
    const cardW = this.cards[0].offsetWidth;
    const edge = Math.max(0, (this.viewport.clientWidth - cardW) / 2);
    this.track.style.paddingLeft = edge + 'px';
    this.track.style.paddingRight = edge + 'px';

    this.maxX = Math.max(0, this.track.scrollWidth - this.viewport.clientWidth);
    this.style.height = (this.viewport.offsetHeight + this.maxX) + 'px';
  }


  onResize() {
    this.measure();
    this.update();
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(() => {
      this.update();
      this.ticking = false;
    });
  }

  update() {
    if (this.mode !== 'pinned') return;
    const rect = this.getBoundingClientRect();
    const scrollable = this.offsetHeight - this.viewport.offsetHeight;
    let progress = scrollable > 0 ? (-rect.top / scrollable) : 0;
    progress = Math.min(1, Math.max(0, progress));

    const x = progress * this.maxX;
    this.track.style.transform = 'translate3d(' + (-x) + 'px,0,0)';

    const center = x + this.viewport.clientWidth / 2;
    let best = 0;
    let bestDist = Infinity;
    for (let i = 0; i < this.cards.length; i++) {
      const card = this.cards[i];
      const cardCenter = card.offsetLeft + card.offsetWidth / 2;
      const dist = Math.abs(cardCenter - center);
      if (dist < bestDist) { bestDist = dist; best = i; }
    }
    this.setActive(best);
  }

  setActive(index) {
    if (index === this.activeIndex || index < 0) return;
    this.activeIndex = index;
    for (let i = 0; i < this.bgLayers.length; i++) {
      this.bgLayers[i].classList.toggle('is-active', i === index);
    }
    if (this.counter) {
      this.counter.textContent = String(index + 1).padStart(2, '0');
    }
  }

  teardown() {
    document.removeEventListener('scroll', this.onScroll, { capture: true });
    window.removeEventListener('resize', this.onResize);
    if (this.io) { this.io.disconnect(); this.io = null; }
    this.classList.remove('sqsh-hscroll--pinned');
    this.style.removeProperty('height');
    if (this.track) {
      this.track.style.transform = '';
      this.track.style.paddingLeft = '';
      this.track.style.paddingRight = '';
    }
    this.activeIndex = -1;
  }

  disconnectedCallback() {
    this.teardown();
    if (this.reduce && this.reduce.removeEventListener) {
      this.reduce.removeEventListener('change', this.applyMode);
    }
    if (this.desktop && this.desktop.removeEventListener) {
      this.desktop.removeEventListener('change', this.onResize);
    }
  }
}

if (!customElements.get('sqsh-horizontal-scroll')) {
  customElements.define('sqsh-horizontal-scroll', SqshHorizontalScroll);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-list"] && !Shopify.designMode) return;
  try {
    
  class MaterialsTabs extends HTMLElement {
    constructor() {
      super();
      this.triggers = [];
      this.panels = [];
    }

    connectedCallback() {
      this.triggers = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      if (this.triggers.length === 0) return;

      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', this.handleClick.bind(this));
        trigger.addEventListener('keydown', this.handleKeydown.bind(this));
      });
    }

    handleClick(event) {
      const trigger = event.currentTarget;
      this.activate(trigger);
    }

    handleKeydown(event) {
      const currentIndex = this.triggers.indexOf(event.currentTarget);
      let nextIndex = null;

      switch (event.key) {
        case 'ArrowDown':
        case 'ArrowRight':
          nextIndex = (currentIndex + 1) % this.triggers.length;
          break;
        case 'ArrowUp':
        case 'ArrowLeft':
          nextIndex = (currentIndex - 1 + this.triggers.length) % this.triggers.length;
          break;
        case 'Home':
          nextIndex = 0;
          break;
        case 'End':
          nextIndex = this.triggers.length - 1;
          break;
        default:
          return;
      }

      event.preventDefault();
      const nextTrigger = this.triggers[nextIndex];
      this.activate(nextTrigger);
      nextTrigger.focus();
    }

    activate(activeTrigger) {
      const activeIndex = activeTrigger.dataset.tabIndex;

      this.triggers.forEach((trigger) => {
        const isActive = trigger === activeTrigger;
        trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
        trigger.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      this.panels.forEach((panel) => {
        const isActive = panel.dataset.tabIndex === activeIndex;
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }
  }

  if (!customElements.get('materials-tabs')) {
    customElements.define('materials-tabs', MaterialsTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
